/*eslint-disable */

// import CloudinaryVideoPlayer from './CloudinaryVideoPlayer'
import * as cloudinary from 'cloudinary-core'

class App {
  constructor(selector) {
    this.ready = document.readyState === 'interactive'

    if (!this.ready) {
      document.addEventListener('DOMContentLoaded', () => {
        this.element = document.querySelector(selector)

        if (typeof this.callback === 'function') {
          this.callback()
        }
      })
    } else {
      this.element = document.querySelector(selector)
    }
  }

  onReady(callback) {
    this.callback = callback
    this.init()

    if (this.ready) {
      callback()
    }
  }

  initMenu() {}

  initVideoPlayer() {
    let videos = document.getElementsByClassName('cloudinary-video-player')
    Array.from(videos, function(el) {
      // let vp = new CloudinaryVideoPlayer(el)
    })
  }

  initResponsivePicture() {
    let cl = cloudinary.Cloudinary.new({
      cloud_name: config.cloudinary.options.cloud_name,
    })
    cl.responsive()
  }

  init() {
    // this.initMenu()
    // this.initVideoPlayer()
    this.initResponsivePicture()
  }
}

export default App
